/** Palette couleurs standardisée — EMIS Dataviz (SOTA 2026) */
export const CHART_COLORS = [
    '#dc2626', // brand-600 (rouge EMIS)
    '#10b981', // emerald-500
    '#f59e0b', // amber-400
    '#3b82f6', // blue-500
    '#9ca3af', // gray-400
    '#8b5cf6', // violet-500
    '#ec4899', // pink-500
    '#06b6d4', // cyan-500
    '#84cc16', // lime-500
    '#f97316', // orange-500
];

/** Couleurs sémantiques pour les indicateurs delta */
export const DELTA_COLORS = {
    positive: '#10b981',
    negative: '#ef4444',
    neutral: '#9ca3af',
} as const;

/** Couleurs pour dans/hors délais */
export const DELAY_COLORS = {
    inTime: '#10b981',
    late: '#ef4444',
    unknown: '#9ca3af',
} as const;

/** Couleurs pour les barres empilées (marge brute) */
export const MARGIN_COLORS = {
    monthly: '#3b82f6',
    cumulative: '#10b981',
} as const;
